import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

export interface ILevel {
    Rows: ILevelRow[];
    getLevelMap(): string;
}

export interface ITile {
    type: string;
}

export interface ILevelRow {
    tiles: ITile[];
}

export interface ILevelData {
    Name: string;
    LevelType: LevelTypeEnum; 
    Content: string;
}

export interface INewLevelData {
    name: string;
    levelType: LevelTypeEnum; 
    rows: number;
    columns: number;
}

export enum LevelTypeEnum {
    Empty = 0,
    Tropical = 1,
    Desert = 2
}

export class Level implements ILevel {
    Rows: ILevelRow[];
    

    /**
     *
     */
    constructor(levelMap?: string) {
        this.Rows = [];
        if (levelMap != null && levelMap.trim().length > 0) {
            let tiles: ITile[] = [];
            levelMap.split('').forEach((char, idx)=>{
                if (char == '\n') {
                    this.Rows.push({tiles: tiles});
                    tiles = [];
                } else if (char != '\r') {
                    tiles.push({type: char});
                }
            });
        }

    }
    getLevelMap(): string {
        var result: string = "";
        this.Rows.forEach((row, index)=> {
            row.tiles.forEach((tile, idx)=>{
                result+= tile.type;
            });
            result += '\n';
        });
        return result;
    }
   
}

export interface ILevelType {
    id: number;
    name: string;
    tiles: string;
}



@Injectable()
export class LevelService implements OnDestroy  {
    
    levelTypes: ILevelType[] = [
        { 
            id: 1,
            name: "Tropical",
            tiles: " ABCDEFGHIJKLMNOPQRSTUVWXYZ|abcdefghijklmstuvwxyz|0123`~"
        },
        { 
            id: 2,
            name: "Desert",
            tiles: " ABCDEFGHIOPRW|abcdefghijklmz|23`~"
        }
    ];
    private _levelBaseUrl = environment.basePozzwareUrl + 'api/levels/';


    constructor(private _http: HttpClient) {
        
    }

    ngOnDestroy() {
        //console.log("Destroying MenuService");
        Object.keys(this).map(k => {
            this[k] = null;
        });
    }

    getLevelList(): Observable<string[]> {
        let headers = new HttpHeaders();
        headers = headers.append("Content-Type", "application/json");
        return this._http.get(this._levelBaseUrl, { headers: headers}).map((data: any)=>{ return data });
    }

    getLevel(name: string): Observable<Level> {
        let headers = new HttpHeaders();
            headers = headers.append("Content-Type", "application/json");
        return this._http.get(this._levelBaseUrl + name, { headers: headers})
            .map((data: ILevelData) => {
                return new Level(data.Content);
            });
    }

    saveLevel(name: string, content: string): Observable<string> {
        let headers = new HttpHeaders();
            headers = headers.append("Content-Type", "application/json");
        return this._http.put(this._levelBaseUrl + name, { value: content }, {  responseType: 'text', headers: headers})
    }

    getLevelType(id: number): ILevelType{
        var result = this.levelTypes.filter((value, idx)=>{
            if (value.id == id) return value;
        });
        return result[0];
    }



   
}



// WEBPACK FOOTER //
// ./src/app/_service/level.service.ts